import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Radio, Select } from "antd";
import Server from "./../../Server.js";

function Chart(props) {
  const [time, SetTime] = useState("today");
  const options = props.options || {};
  const myServer = new Server();

  return (
      <HighchartsReact highcharts={Highcharts} options={options}  oneToOne={true} />
  );
}

export default Chart;
